
import React, { useState, useRef, useEffect } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  get_AstroData,
  get_AstrologerSingleData,
  get_SkillData,
  get_LanguagesData,
  get_CategoryData,
} from "../../../store/actions/CommanAction";
import { setAstroId } from "../../../store/Action_Types";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import user from "./../../../images/task/user.jpg";
import AstrologerAdd from "./AstrologerAdd";
import Select from "react-select";
import { baseURLS } from "../../../services/AxiosInstance";
import About from "./About";
import axios from "axios";
import * as XLSX from "xlsx";


const PendingApporeved = () => {
  const dispatch = useDispatch();
  const effectRan = useRef(false);

  const AstroData = useSelector((state) => state.feedBackReducer.AstroData) || [];
  const AstrologerSingleData = useSelector(
    (state) => state.feedBackReducer.AstrologerSingleData
  );
  const selectedAstroId = useSelector(
    (state) => state.feedBackReducer.selectedAstroId
  );


  const [IsActive, setIsActive] = useState("1");
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [location, setLocation] = useState("");
  const [loading, setloading] = useState(false);


  const [EditModalAstro, setEditModalAstro] = useState(false);
  const [showFullEditModal, setShowFullEditModal] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [avatarUrl, setavatarUrl] = useState("")
    const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
  const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);
    const [dateError, setDateError] = useState("");

    const isDateRangeValid = () => {
      if (!startTime || !endTime) return true;
      try {
        return new Date(startTime) <= new Date(endTime);
      } catch (err) {
        return true;
      }
    };

    const applyFilters = () => {
      if (!isDateRangeValid()) {
        setDateError("Start date cannot be after End date");
        return;
      }
      setDateError("");
      setloading(true);
      dispatch(get_AstroData(IsActive, startTime, endTime, name, mobileNumber, location, "0", setloading));
      setloading(false);
    };




  const [aboutusdata, setaboutusdata] = useState("");
  const [AstrologerID, setAstrologerID] = useState("");
  const [AboutValue, SetAboutValue] = useState({
    ExperiencedYears: "",
    Languages: "",
    Aboutme: "",
    skills: "",
    CategoryID: "",
    AstrologerID: "",
    ModifiedByUser: 1,
    IsActive: "1",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil((AstroData?.length || 0) / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAstros = AstroData?.slice(startIndex, endIndex) || [];



  const SkillsData = useSelector((state) => state.feedBackReducer.SkillsData) || [];
  const LanguagesData = useSelector(
    (state) => state.feedBackReducer.LanguagesData
  ) || [];
  const CategroyData = useSelector((state) => state.feedBackReducer.CategoryData) || [];


  const userdata = sessionStorage.getItem("UserData");
  const parsedUserData = userdata ? JSON.parse(userdata) : null;
  const adminusername = parsedUserData?.userName;
  const [videostrimingprice, setvideostrimingprice] = useState("")
  const [displayname, setdisplayname] = useState("")
  const [displayError, setDisplayError] = useState("");
  const [checkingDisplay, setCheckingDisplay] = useState(false);


  const [ReviewData, setReviewData] = useState({
    AstrologerID: "",
    OriginalPricePerMin: "",
    PricePerMin: "",
    Reviews: "",
    Rating: "",
    ModifiedByUser: "1",
    PujaSuggestionPer: "",
    GemStoneSuggestionPer: "",
  });
  const [priceastroid, setpriceastroid] = useState(null);


  useEffect(() => {
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    setloading(true);
    dispatch(get_AstroData(IsActive, startTime, endTime, name, mobileNumber, location, "0", setloading));

    dispatch(get_SkillData(true));
    dispatch(get_LanguagesData(true));
    dispatch(get_CategoryData(true));
  }, []);


  useEffect(() => {
    if (!name && !location && !mobileNumber) {
      dispatch(get_AstroData(IsActive, startTime, endTime, "", "", "", "0", setloading));
      return;
    }

    if (name.length < 3 && location.length < 3 && mobileNumber.length < 3) return;

    const t = setTimeout(() => {
      setloading(true);
      dispatch(get_AstroData(IsActive, startTime, endTime, name, mobileNumber, location, "0", setloading));
      setloading(false);
    }, 500);

    return () => clearTimeout(t);
  }, [name, location, mobileNumber, IsActive, dispatch]);


  useEffect(() => {
    if (AstrologerSingleData && AstrologerSingleData.length > 0) {
      const data = AstrologerSingleData[0];

      SetAboutValue((prev) => ({
        ...prev,
        ModifiedByUser: 1,
        AstrologerID: data?.ID || prev.AstrologerID,
        ExperiencedYears: data?.ExperiencedYears || prev.ExperiencedYears,
        skills: data?.skills || prev.skills,
        CategoryID: data?.CategoryID || prev.CategoryID,
        Languages: data?.Languages || prev.Languages,
        Aboutme: data?.Aboutme || prev.Aboutme,
      }));
      setaboutusdata(data?.Aboutme || "");
      setAstrologerID(data?.ID || "");
      setavatarUrl(data?.AvatarUrl || "")

      setReviewData((r) => ({
        ...r,
        AstrologerID: data?.ID,
        OriginalPricePerMin: data?.OriginalPricePerMin || r.OriginalPricePerMin,
        PricePerMin: data?.PricePerMin || r.PricePerMin,
        Reviews: data?.Reviews || r.Reviews,
        Rating: data?.Rating || r.Rating,
        GemStoneSuggestionPer: data?.GemStoneSuggestionPer || r.GemStoneSuggestionPer,
        PujaSuggestionPer: data?.PujaSuggestionPer || r.PujaSuggestionPer,
      }));
      setdisplayname(data?.DisplayName || "")
    } else {

      SetAboutValue({
        ExperiencedYears: "",
        Languages: "",
        Aboutme: "",
        skills: "",
        CategoryID: "",
        AstrologerID: "",
        ModifiedByUser: 1,
        IsActive: "1",
      });
      setaboutusdata("");
      setReviewData({
        AstrologerID: "",
        OriginalPricePerMin: "",
        PricePerMin: "",
        Reviews: "",
        Rating: "",
        ModifiedByUser: "1",
        PujaSuggestionPer: "",
        GemStoneSuggestionPer: "",
      });
    }
  }, [AstrologerSingleData]);


  const handleToggleStatusClick = async (row) => {

    SetAboutValue({
      ExperiencedYears: "",
      Languages: "",
      Aboutme: "",
      skills: "",
      CategoryID: "",
    })
    setaboutusdata("");
    setavatarUrl("");
    setReviewData({
      AstrologerID: "",
      OriginalPricePerMin: "",
      PricePerMin: "",
    });
    if (row?.Isverified) {

      swal("Already Approved", "This astrologer is already approved.", "info");
      return;
    }


    dispatch(setAstroId(row.ID));
    await dispatch(get_AstrologerSingleData(row.ID));
    setpriceastroid(row.ID);
    setEditModalAstro(true);


    dispatch(get_SkillData(true));
    dispatch(get_LanguagesData(true));
    dispatch(get_CategoryData(true));
  };


  const HandleChangeAbout = (e) => {
    const { name, value } = e.target;
    if (name === "ExperiencedYears") {
      if (!/^\d*\.?\d*$/.test(value)) {
        return;
      }
    }
    const Aboutvalue = { ...AboutValue, [name]: value };
    SetAboutValue(Aboutvalue);

    if (name === "Aboutme") {
      setaboutusdata(value);
    }
  };


  const SkillsChange = (e) => {
    const id = [];
    if (e) {
      e.forEach((item) => {
        id.push(item.value);
      });
      SetAboutValue({
        ...AboutValue,
        skills: id.toString(),
      });
    } else {
      SetAboutValue({
        ...AboutValue,
        skills: "",
      });
    }
  };
  const CategoryChange = (e) => {
    const id = [];
    if (e) {
      e.forEach((item) => {
        id.push(item.value);
      });
      SetAboutValue({
        ...AboutValue,
        CategoryID: id.toString(),
      });
    } else {
      SetAboutValue({
        ...AboutValue,
        CategoryID: "",
      });
    }
  };
  const LanguageChange = (e) => {
    const id = [];
    if (e) {
      e.forEach((item) => {
        id.push(item.value);
      });
      SetAboutValue({
        ...AboutValue,
        Languages: id.toString(),
      });
    } else {
      SetAboutValue({
        ...AboutValue,
        Languages: "",
      });
    }
  };


  const customPostData = async (url, postdata) => {
    try {
      const response = await fetch(`${baseURLS}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postdata),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      // setaboutusdata(data) 
      return data;
    } catch (error) {
      console.error("Error while fetching:", error);
      return { success: false, data: null, Message: error.message };
    }
  };

  const Aboutusfunction = async () => {
    if (!selectedAstroId && !AstrologerID) {
      swal("Select Astrologer", "Astrologer not selected", "warning");
      return;
    }

    setIsGenerating(true);

    const postdata = { AstroId: selectedAstroId || AstrologerID };
    const res = await customPostData("Gemini/ask", postdata);

    if (res?.success && typeof res?.data === "string") {
      const aboutMeMatch = res.data.match(/ABOUT_ME:\s*([\s\S]*?)(?=\n*\s*SERVICES:|$)/);

      if (aboutMeMatch) {
        const aboutMe = aboutMeMatch[1].trim();
        setaboutusdata(aboutMe);
      } else {
        setaboutusdata(res.data);
      }
    } else if (typeof res === "string") {
      setaboutusdata(res);
    } else {
      swal("Error", "AI could not generate about text", "error");
      setaboutusdata("");
    }

    setIsGenerating(false);
  };



  const handleUpdateAndApprove = async () => {

    if (!AboutValue?.ExperiencedYears) {
      return swal("Oops", "Please fill ExperiencedYears.", "error");
    }
    if (!AboutValue?.skills) {
      return swal("Oops", "Please fill skills.", "error");
    }
    if (!AboutValue?.CategoryID) {
      return swal("Oops", "Please fill Category.", "error");
    }
    if (!AboutValue?.Languages) {
      return swal("Oops", "Please fill Languages.", "error");
    }
    if (!ReviewData?.PricePerMin) {
      return swal("Oops", "Please fill Current Price.", "error");
    }
    if (!videostrimingprice) {
      return swal("Oops", " Please fill Video Striming Price.", "error");
    }
    if (!displayname) {
      return swal("Oops", " Please fill Display Name.", "error");
    }

    if (!AboutValue?.Aboutme) {
      return swal("Oops", "Please fill About Me.", "error");
    }
    if (!avatarUrl && !file) {
      return swal("Oops", "Please upload Photo.", "error");
    }
    if (displayError) {
  return swal("Error", "Display Name already exists", "error");
}


    const today = new Date().toISOString().split("T")[0];

    const aboutPostData = {
      Aboutme: aboutusdata || AboutValue.Aboutme,
      AstrologerID: selectedAstroId || AstrologerID,
      CategoryID: AboutValue.CategoryID,
      Languages: AboutValue.Languages,
      skills: AboutValue.skills,
      ExperiencedYears: AboutValue.ExperiencedYears,
    };

    const reviewPostData = {
      AstrologerID: priceastroid,
      OriginalPricePerMin: ReviewData?.OriginalPricePerMin || "0",
      PricePerMin: ReviewData?.PricePerMin || "0",
    };

    const approvePostData = {
      AstrologerID: priceastroid,
      IsVerified: true,
      VerifiedDate: today,
      VerifiedBy: adminusername,
      ModifiedByUser: 1,
      DisplayName: displayname,
    };
    const videostrimingPostData = {
      AstroID: priceastroid,
      VideoStreamPricePerMin: videostrimingprice || "0",
    }

    try {
      await AddUpdate("Astrologer/Update_VideoStreamPricePerMin", videostrimingPostData);

      await AddUpdate("Astrologer/UpdateAstrologerAboutMe", aboutPostData);


      await AddUpdate("Astrologer/UpdateAstrologerReview", reviewPostData);


      await AddUpdate("Astrologer/Update_AstroApprove", approvePostData);

      swal("Good job!", "Successfully Updated & Approved", "success");

      dispatch(get_AstroData("1", "", "", " ", "", "", "0"));
      setEditModalAstro(false);
    } catch (err) {
      console.error(err);
      swal("Error", "Failed to update and approve", "error");
    }
  };


  useEffect(() => {
    setCurrentPage(1);
  }, [AstroData]);


  const handleChange = (e) => {
    const allowedFields = [
      "Reviews",
      "OriginalPricePerMin",
      "Rating",
      "PricePerMin",
      "GemStoneSuggestionPer",
      "PujaSuggestionPer",
    ];

    if (allowedFields.includes(e.target.name)) {
      const ele = e.target.value.replace(/[^0-9.]/g, "");

      if (ele.includes(".")) {
        if (ele.length === 16) {
          setReviewData({ ...ReviewData, [e.target.name]: ele });
        } else {
          const decimalPart = ele.substr(ele.indexOf(".") + 1).slice(0, 2);
          const checkDot = decimalPart.match(/\./g);

          if (!checkDot) {
            setReviewData({
              ...ReviewData,
              [e.target.name]: ele.substring(0, ele.indexOf(".")) + "." + decimalPart,
            });
            return;
          } else {
            return;
          }
        }
      } else {
        setReviewData({ ...ReviewData, [e.target.name]: ele });
      }
    } else {
      setReviewData({ ...ReviewData, [e.target.name]: e.target.value });
    }
  };

  const updateapifunction = () => {
    dispatch(get_AstroData("1", "", "", " ", "", "", "0"));
  };




  const fileHandler = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) setFile(selectedFile);
  };

  const handleUpdatePhoto = async () => {

    const formData = new FormData();
    const dataObject = {
      AstrologerID: selectedAstroId,
      ModifiedByUser: '1',
    };
    formData.append('Data', JSON.stringify(dataObject));
    formData.append('File', file);
    try {
      await AddUpdate('Astrologer/UpdateAstrologerPhoto', formData);
      dispatch(get_AstroData("1", "", "", " ", "", "", "0"));


      swal('Good job!', 'Successfully Added', 'success');
    }

    finally {

    }
  };
  const checkDisplayExist = async (value) => {
    if (!value) {
      setDisplayError("");
      return;
    }

    try {
      setCheckingDisplay(true);

      const payload = {
        AstroID: selectedAstroId || AstrologerID || 0,
        DisplayName: value,
      };

      const res = await AddUpdate("Astrologer/AstrlogerCheckNameExist", payload);

      const parsed = JSON.parse(res?.data?.data || "{}");


      const exist = parsed?.Table?.[0]?.AstrologerExist;

      if (exist == 1) {
        setDisplayError("Display Name already exists");
      } else {
        setDisplayError("");
      }

    } catch (err) {
      console.log(err);
    } finally {
      setCheckingDisplay(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      checkDisplayExist(displayname);
    }, 500);

    return () => clearTimeout(timer);
  }, [displayname]);


  

   const handleExportToExcel = () => {
        if (!AstroData || AstroData.length === 0) {
            swal("No data available to export!", "", "info");
            return;
        }

        const exportData = AstroData.map((row, index) => ({
            "S.No": index + 1,
        
            // "Name": row.DisplayName,
            "Name": [row?.FirstName, row?.LastName].filter(Boolean).join(" ") || "-",
            "Mobile Number": row.RegMobileNo,
            "Gender": row.Gender || "N/A",
            "Experienced Years": row.ExperiencedYears || "N/A",
           "Created Time": row.CreatedTime
    ? new Date(row.CreatedTime).toLocaleDateString("en-GB") 
    : "N/A",
            "POB": row.POB || "N/A",
         
        
           
        }));


        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Approved List");


        XLSX.writeFile(workbook, "Pending_Approved_List.xlsx");


        setTimeout(() => {
            swal("Download complete!", "Your Pending Approved list has been saved.", "success");
        }, 1000);
    };



  return (
    <div
      className="astro-list-container"
      style={{
        background: "#fff",
        borderRadius: "10px",
        padding: "24px",
        marginTop: "20px",
      }}
    >
      <div
        className="astro-list-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1.5rem",
        }}
      >
        <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Pending Approved List</h2>
      </div>





<div className="row g-3 mb-3">
  {/* First Row */}
  <div className="col-md-3">
    <label className="form-label fw-semibold">Start Date</label>
    <input
      type="date"
      className="form-control filter-date"
      value={startTime}
      onChange={(e) => setStartTime(e.target.value)}
    />
  </div>

  <div className="col-md-3">
    <label className="form-label fw-semibold">End Date</label>
    <input
      type="date"
      className="form-control filter-date"
      value={endTime}
      onChange={(e) => setEndTime(e.target.value)}
    />
  </div>
</div>

<div className="row g-3 align-items-end mb-4">
  {/* Second Row */}
  <div className="col-md-3">
    <label className="form-label fw-semibold">Mobile Number</label>
    <input
      type="text"
      className="form-control filter-date"
      placeholder="Search Mobile"
      value={mobileNumber}
      onChange={(e) => setMobileNumber(e.target.value)}
    />
  </div>

  <div className="col-md-3">
    <label className="form-label fw-semibold">Name</label>
    <input
      type="text"
      className="form-control filter-date"
      placeholder="Search Name"
      value={name}
      onChange={(e) => setName(e.target.value)}
    />
  </div>

  <div className="col-md-auto">
    <button
      className="btn btn-warning px-4"
      onClick={applyFilters}
    >
      Apply Filters
    </button>
  </div>

  <div className="col-md-auto">
    <button
      className="btn btn-secondary px-4"
      onClick={handleExportToExcel}// changes
    >
      Export Excel
    </button>
  </div>
</div>


      <div style={{ maxHeight: "400px", overflowY: "auto" }} className="table-responsive">
        <table className="table astro-list-table" style={{ width: "100%" }}>
          <thead
            style={{
              position: "sticky",
              top: 0,
              background: "#0d2235",
              color: "#fff",
              fontSize: "13px",
              zIndex: 2,
            }}
          >
            <tr>
              <th style={{ fontSize: "13px" }}>Image</th>
              <th style={{ fontSize: "13px" }}>Name</th>
              <th style={{ fontSize: "13px" }}>Mobile No</th>
              <th style={{ fontSize: "13px" }}>Gender</th>
              {/* <th style={{ fontSize: "13px" }}>VerifiedBy</th> */}
              <th style={{ fontSize: "13px" }}>CreatedDate</th>
              <th style={{ fontSize: "13px" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentAstros && currentAstros.length > 0 ? (
              currentAstros.map((row, idx) => (
                <tr key={row.ID || idx}>
                  <td
                    style={{ cursor: "pointer" }}

                  >
                    <img
                      src={row.AvatarUrl ? `https://${row.AvatarUrl.replace(/\\/g, "/")}` : user}
                      alt="profile"
                      className="astro-img"
                      style={{ width: 40, height: 40, borderRadius: "50%" }}
                    />
                  </td>
                <td style={{ fontWeight: "bold" }}>
  {[row?.FirstName, row?.LastName].filter(Boolean).join(" ") || "-"}
</td>
                  <td>{row.RegMobileNo}</td>
                  <td>{row.Gender || "N/A"}</td>
                  {/* <td>{row.VerifiedBy || "N/A"}</td> */}
                  {/* <td>{row.CreatedTime || "N/A"}</td> */}
                  <td>{ row.CreatedTime
    ? new Date(row.CreatedTime).toLocaleDateString("en-GB") 
    : "N/A"}</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        style={{ cursor: "pointer" }}
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={`toggle-${row.ID}`}
                        checked={!!row.Isverified}
                        onChange={() => handleToggleStatusClick(row)}
                      />
                      <label className="form-check-label" htmlFor={`toggle-${row.ID}`}>
                        {row.Isverified ? "Approved" : "Not Approved"}
                      </label>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center py-4">
                  There are no data to display
                </td>
              </tr>
            )}
          </tbody>
        </table>


        {AstroData && AstroData.length > 0 && (
          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span style={{ fontWeight: 600 }}>
              Page {currentPage} of {totalPages}   <span style={{marginLeft:"30px"}}>      (Total {AstroData?.length || 0} records)</span>
            </span>

            <button
              className="btn btn-outline-primary"
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}



      </div>



      <Modal className="modal fade" show={EditModalAstro} onHide={() => setEditModalAstro(false)} size="lg">
        <div>
          <form>
            <div className="modal-header">
              <h4 className="modal-title fs-20">Update About Us & Price Details</h4>
              <button type="button" className="btn-close" onClick={() => setEditModalAstro(false)}></button>
            </div>

            <div className="modal-body">
              <div className="add-contact-box">
                <div className="row">


                  <div className="col-lg-12 mt-2 position-relative">
                    <div className="form-group mb-3">
                      <label htmlFor="comment" className="text-black font-w600">About Details<span className="text-danger">*</span></label>

                      <div style={{ position: "relative" }}>
                        <textarea
                          rows={12}
                          name="Aboutme"
                          placeholder="About Me"
                          value={aboutusdata || AboutValue?.Aboutme || ""}
                          onChange={HandleChangeAbout}
                          className="form-control"
                          disabled={isGenerating}
                          style={isGenerating ? { opacity: 0.6, pointerEvents: "none" } : {}}
                        />


                        {isGenerating && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              borderRadius: "8px",
                              padding: "15px 25px",
                              textAlign: "center",
                              zIndex: 2,
                              fontWeight: 600,
                              color: "#333",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
                            }}
                          >
                            <div className="spinner-border text-primary mb-2" role="status" style={{ width: "2rem", height: "2rem" }}>
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <div>Generating...</div>
                          </div>
                        )}
                      </div>
                    </div>

                    <button
                      className="btn btn-primary me-2"
                      type="button"
                      onClick={Aboutusfunction}
                      disabled={isGenerating}
                    >
                      {isGenerating ? "Generating..." : "Generate About (AI)"}
                    </button>

                  </div>

                  <div className="row" style={{ width: "100%" }}>
                    <div className="col-lg-4">
                      <div className="form-group mb-3" style={{ marginTop: "8px" }}>
                        <label htmlFor="author" className="text-black font-w600">
                          Experience <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="ExperiencedYears"
                          placeholder="Experience"
                          value={AboutValue?.ExperiencedYears || ""}
                          maxLength={2}
                          onChange={HandleChangeAbout}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-group mb-3">
                        <label htmlFor="author" className="text-black font-w600">
                          Language <span className="text-danger">*</span>
                        </label>

                        <Select
                          name="Languages"
                          isMulti
                          isClearable
                          value={
                            LanguagesData &&
                              AboutValue?.Languages
                              ? LanguagesData.filter((language) =>
                                AboutValue?.Languages?.split(",").includes(language.value?.toString())
                              )
                              : []
                          }
                          options={LanguagesData}
                          onChange={LanguageChange}
                          placeholder="Select languages"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label htmlFor="author" className="text-black font-w600">
                        Skills <span className="text-danger">*</span>
                      </label>

                      <Select
                        name="skills"
                        isMulti
                        isClearable
                        value={
                          SkillsData &&
                            AboutValue?.skills
                            ? SkillsData.filter((skill) =>
                              AboutValue?.skills?.split(",").includes(skill.value?.toString())
                            )
                            : []
                        }
                        options={SkillsData}
                        onChange={SkillsChange}
                        placeholder="Select Skills"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label htmlFor="author" className="text-black font-w600">
                        Category <span className="text-danger">*</span>
                      </label>

                      <Select
                        name="CategoryID"
                        isMulti
                        isClearable
                        value={
                          CategroyData &&
                            AboutValue?.CategoryID
                            ? CategroyData.filter((cat) =>
                              AboutValue?.CategoryID?.split(",").includes(cat.value?.toString())
                            )
                            : []
                        }
                        options={CategroyData}
                        onChange={CategoryChange}
                        placeholder="Select Categories"
                      />
                    </div>
                  </div>


                  <div className="row" style={{ width: "100%" }}>

                    <div className="form-group mb-3 col-md-4">
                      <label className="text-black font-w500">Original Price</label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="OriginalPricePerMin"
                          required="required"
                          placeholder="Enter Your Original Price"
                          value={ReviewData?.OriginalPricePerMin || ""}
                          onChange={handleChange}
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>

                    <div className="form-group mb-3 col-md-4">
                      <label className="text-black font-w500">
                        Current Price <span className="text-danger">*</span>
                      </label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="PricePerMin"
                          required="required"
                          placeholder="Enter Your Current Price"
                          value={ReviewData?.PricePerMin || ""}
                          onChange={handleChange}
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ width: "100%" }}>

                    <div className="form-group mb-3 col-md-4">
                      <label className="text-black font-w500">
                        VideoStriming Price <span className="text-danger">*</span>
                      </label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="VideoStrimingPrice"
                          required="required"
                          placeholder="Enter Video Striming Price"
                          value={videostrimingprice || ""}
                          onChange={(e) => setvideostrimingprice(e.target.value)}
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>

                    <div className="form-group mb-3 col-md-4">
                      <label className="text-black font-w500">
                        Display Name <span className="text-danger">*</span>
                      </label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className={`form-control ${displayError ? "border-danger" : ""}`}
                          autoComplete="off"
                          name="DisplayName"
                          required="required"
                          placeholder="Enter Display Name"
                          value={displayname || ""}
                          onChange={(e) => setdisplayname(e.target.value)}
                        />

                        {displayError && (
                          <small className="text-danger">{displayError}</small>
                        )}

                        {checkingDisplay && (
                          <small>Checking...</small>
                        )}
                        <span className="validation-text"></span>
                      </div>
                    </div>


                  </div>

                  <div
                    className="col-xl-3 order_1 justify-content-center d-flex align-items-start"
                    style={{ marginTop: "38px" }}
                  >
                    <div className="profile-info">
                      <div className="profile-photo">
                        <div className="image-placeholder">
                          <div className="avatar-edit">
                            <input
                              type="file"
                              onChange={fileHandler}
                              id="imageUpload"
                              onClick={(event) => (event.target.value = null)}
                              style={{ display: "none" }}
                            />
                            <label
                              htmlFor="imageUpload"
                              style={{
                                cursor: "pointer",
                                opacity: 1,
                              }}
                            ></label><span className="text-danger">*</span>
                          </div>

                          <div className="avatar-preview">
                            <div id="imagePreview">
                              <img
                                id="saveImageFile"
                                src={
                                  file
                                    ? URL.createObjectURL(file)
                                    : avatarUrl
                                      ? `https://${avatarUrl.replace(/\\/g, "/")}`
                                      : user
                                }
                                alt={file?.name || "User Avatar"}
                                style={{
                                  cursor: "pointer",
                                  width: "120px",
                                  height: "120px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginLeft: "10px",
                                  objectFit: "contain",
                                  borderRadius: "8px",
                                  backgroundColor: "#f5f5f5",
                                }}
                              />
                            </div>
                          </div>

                          <button
                            onClick={handleUpdatePhoto}
                            disabled={!file || uploading}
                            className="btn btn-primary text-white p-1"
                            style={{ marginLeft: "30px", width: "120px", marginTop: "10px" }}
                          >
                            {uploading ? "Uploading..." : "Upload Photo"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>




                  <div className="row">
                    <div className="col-12">
                      <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
                        <button
                          className="btn btn-primary"
                          style={{ width: "140px" }}
                          type="button"
                          onClick={handleUpdateAndApprove}
                        >
                          Update & Approve
                        </button>

                        <button
                          className="btn btn-danger"
                          style={{ width: "80px" }}
                          type="button"
                          onClick={() => setEditModalAstro(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <Modal className="modal fade" show={showFullEditModal} onHide={() => setShowFullEditModal(false)} size="lg">
        <AstrologerAdd astrologerId={selectedAstroId} onClose={() => setShowFullEditModal(false)} refereshfunction={updateapifunction} />
      </Modal>
    </div>
  );
};

export default PendingApporeved;
